import React from 'react';

export const Badge = ({ badge }) => {
  const hasBadge = typeof badge !== 'undefined' && badge > 0;
  if (!hasBadge) return null;
  return <span className="text-white badge rounded-pill bg-danger ml-2">{badge > 999 ? '+999' : badge}</span>;
};
